module.exports = __webpack_public_path__ + "img/naotravelco-virtuoso-white.cb8cdc6d.png";